// Lodash
import _isNil from 'lodash/isNil'

// Constants
import {
  AMWELL_AGENT_SIZE,
  AMWELL_AGENT_MARGIN_BOTTOM
} from '../../constants/amwell'

const EFFECTIVE_BADGE_HEIGHT = AMWELL_AGENT_SIZE + AMWELL_AGENT_MARGIN_BOTTOM

/**
 * Returns the paragraph element that currently has the focus on
 * @param {*} event Any valid html events
 * @returns {HTMLElement} Paragraph element that currently has the focus on
 */
const getElementToBeScrolled = () => {
  try {
    // Get the current position of the caret using getSelection
    // Reference: https://developer.mozilla.org/en-US/docs/Web/API/Window/getSelection
    const focusNode = window.getSelection().focusNode

    // All content inside the editor is wrapped inside <p>(paragraph) elements with data-block-type attribute
    // If the content is empty the focusNode will be the <p>(paragraph)
    if (focusNode.nodeType === Node.TEXT_NODE) {
      const closestNode = focusNode.parentNode.closest('p')
      return closestNode
    } else {
      return focusNode
    }
  } catch (error) {
    console.log('Error computing scrollable element', error)
    return null
  }
}

/**
 * Scrolls the window to bring the cursor into the center of viewport
 * @param {*} event Any valid html events
 */
const handleContentFocus = () => {
  try {
    const elementToBeScrolled = getElementToBeScrolled()
    if (_isNil(elementToBeScrolled)) {
      return
    }

    // NOTE: Currently we get the text node where the cursor is active, which can span into multiple
    // lines. Here we consider the bottom of the entire node and not the exact cursor position.
    // TODO: Find a way to calculate the exact position of the cursor and use that position.
    // Onkeydown, OnClick event does gives the exact position using clientY property, but these events
    // won't be triggered while dictating to the section. To maintain consistency we did choose to avoid
    // going that way and choose this so it works the same way in both keyboard and dictation.
    const elementPosition = elementToBeScrolled.getBoundingClientRect().bottom
    const viewableHeightExcludingAgent = window.innerHeight - EFFECTIVE_BADGE_HEIGHT

    // We need to scroll the content only if the element falls below the Agent's starting position
    if (elementPosition > viewableHeightExcludingAgent) {
      // Finding the scrollable note container
      const noteContainerElement = elementToBeScrolled.closest('div[data-cy="note-container-scrollable"]')

      // Calculating the center of the viewport
      const viewPortCenter = Math.round(window.innerHeight / 2)

      // If the viewport center is below the agent starting position then we scroll to agent starting
      // point else we scroll to the center of viewport
      const scrollToHeight = viewPortCenter < viewableHeightExcludingAgent ? viewPortCenter : viewableHeightExcludingAgent

      // Computing the amount of height to be scrolled
      const scrollTopAmount = elementPosition - scrollToHeight
      noteContainerElement.scrollBy({
        top: scrollTopAmount,
        left: 0,
        behavior: 'smooth'
      })
    }
  } catch (error) {
    console.log('Error scrolling content into viewport', error)
  }
}

export { handleContentFocus }
